import logoSvg from '/src/assets/mebi-logo.svg';

interface MebiLogoProps {
  className?: string;
  showText?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  variant?: 'logo-only' | 'logo-text' | 'text-only';
}

/**
 * MebiLogo component - MEBI Logo với nhiều tùy chọn hiển thị
 * 
 * @example
 * ```tsx
 * <MebiLogo size="lg" variant="logo-text" />
 * <MebiLogo size="md" variant="logo-only" />
 * ```
 */
export function MebiLogo({ 
  size = 'md', 
  variant = 'logo-text',
  showText,
  className = "" 
}: MebiLogoProps) {
  // Size mapping for logo
  const logoSizes = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20',
    xxl: 'w-32 h-32',
  };

  // Text size mapping
  const textSizes = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl',
    xxl: 'text-5xl',
  };

  // Determine what to show
  const shouldShowLogo = variant === 'logo-only' || variant === 'logo-text';
  const shouldShowText = showText !== undefined ? showText : (variant === 'text-only' || variant === 'logo-text');

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {shouldShowLogo && (
        <div className={`${logoSizes[size]} flex-shrink-0`}>
          <img 
            src={logoSvg} 
            alt="MEBI Logo" 
            className="w-full h-full object-contain"
          />
        </div>
      )}
      {shouldShowText && (
        <span className={`${textSizes[size]} font-bold text-neutral-1300 leading-none`}>
          MEBI
        </span>
      )}
    </div>
  );
}